import React, { useState } from "react";
import axiosInstance from "../axiosInstance";

const AdminPage = () => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const chargeUser = async () => {
    setLoading(true);
    setMessage(""); // Reset message before the API call

    try {
      const user = JSON.parse(localStorage.getItem("user"));
      let details = {
        restaurantId: user.restaurantId,
      };

      const response = await axiosInstance.post(
        "/api/login/chargeTheUser",
        details
      );
      console.log("User charged successfully:", response.data);
      setMessage("User charged successfully!"); // Set success message
    } catch (error) {
      console.error("Error charging user:", error);
      setMessage("Error charging user. Please try again."); // Set error message
    } finally {
      setLoading(false); // Reset loading state
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center" style={{ minHeight: "800px" }}>
      <h1 className="text-3xl font-bold mb-6">Admin Page</h1>
      <button
        onClick={chargeUser}
        disabled={loading}
        className={`bg-blue-500 text-white font-bold py-3 px-6 rounded-lg transition duration-300 transform ${
          loading ? "opacity-50 cursor-not-allowed" : "hover:scale-105"
        }`}
      >
        {loading ? "Charging..." : "Charge Users"}
      </button>
      {message && <p className="mt-4 text-center">{message}</p>} {/* Display message */}
    </div>
  );
};

export default AdminPage;
